
interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export function ButtonSiguiente({ children, className, type = "button", ...props }: Props) {
    return (
      <button
        type={type}
        className={`${className} flex h-8 w-3/6 xs:w-full transition-colors items-center justify-center bg-zinc-600 shadow-md shadow-zinc-700 rounded-md duration-400 border hover:border-blue-700 active:bg-white active:text-black text-white active:font-extrabold`}
        {...props}
      >
        {children}
      </button>
    );
  };
  

export default ButtonSiguiente;

